import { render } from "./App.vue?vue&type=template&id=051764b4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=051764b4&lang=scss"

import exportComponent from "/Users/yishen/fulai/project/live-streaming/web-liveplay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__